import Model from '../Model'
import moment from "moment";

export default class RAMS extends Model {
    static updateController = new AbortController();

    static getColor(val) {
        const colors = {
            '0': '#F0F0FF',
            '1': '#80c342',
            '2': '#92c740',
            '3': '#a2cd3b',
            '4': '#b8d433',
            '5': '#c7d930',
            '6': '#ffcb0f',
            '8': '#ffbf0f',
            '9': '#fcba19',
            '10': '#fbb418',
            '12': '#faa81a',
            '15': '#f47723',
            '16': '#f37021',
            '18': '#f26221',
            '20': '#f15624',
            '25': '#ee2a26',
        }
        return colors[val];
    }

    getDownloadUrl() {
        return route('api.v2.hsqe.rams.pdf', [this.packageReference, this.id])
    }

    getPrintableUrl() {
        return route('api.v2.hsqe.rams.download', [this.packageReference, this.id])
    }

    async send(to) {
        const url = route('api.v2.hsqe.rams.send', [this.packageReference, this.id])
        let success
        try {
            success = await Http.post(url, {to})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.rams', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async revoke(sendRequestId) {
        const url = route('api.v2.hsqe.rams.revoke', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.rams', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async resend(sendRequestId) {
        const url = route('api.v2.hsqe.rams.resend', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.rams', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async requestApproval(to) {
        const url = route('api.v2.hsqe.rams.request-approval', [this.packageReference, this.id])
        let success
        try {
            success = await Http.post(url, {to})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.rams', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async requestSignature(attendeeId, to) {
        const url = route('api.v2.hsqe.rams.request-signature', [this.packageReference, this.id])
        let success
        try {
            success = await Http.post(url, {attendeeId, to})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.rams', [this.packageReference, this.id]))
        return success;
    }


    getFormAttributes() {
        return this.except(['lastSavedData']);
//        return this.only(['date', 'locationOfWorks', 'keyActivities', 'keyHazards', 'givenByName', 'givenByPosition', 'attendees', 'signature']);
    }

    static parseAttributes(attributes = {}) {
        return attributes
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formattedDate = moment(attributes.date).format('DD/MM/YYYY');
        this.canDelete = (this.externalInvites && this.externalInvites.length === 0)
        this.canDelete = this.status === 'Draft'
        let tokens = [
            this.givenByName,
            this.formattedDate,
            this.packageReference,
            this.contractReference
        ]
        this.tokens = tokens.join('|').toLowerCase();
        if (this.attendees) {
            this.attendees.sort((a, b) => a.order - b.order)
        }
        if (this.externalInvites) {
            this.externalInvites.forEach((i) => {
                i.invitedAt = moment(i.createdOn).format('DD/MM/YYYY HH:mm:ss');
            })
            this.externalInvites.sort((a, b) => moment(b.createdOn).valueOf() - moment(a.createdOn).valueOf())
        }
        this.readonly = this.locked
    }

    static async find(packageReference, id) {
        const data = await Http.get(route('api.v2.hsqe.rams', [packageReference, id]))
        return this.make(data);
    }

    static async all(packageReference = null) {
        const params = {}
        const data = await Http.get(route('api.v2.hsqe.rams.list', [packageReference]), {params})
        return this.make(data)
    }

    static async create(packageReference, id, attributes = {}) {
        const success = await Http.post(route('api.v2.hsqe.rams.create', [packageReference, id]), attributes);
        const data = await Http.get(route('api.v2.hsqe.rams', [packageReference, id]))
        return this.make(data)
    }

    async update(attributes = {}) {
        await this.save(attributes)
//        const data = await Http.get(route('api.v2.hsqe.rams', [this.packageReference, this.id]))
        return this.fill(this.lastSavedData)
    }

    async save(attributes = {}) {
        this.saving = true;
        eventBus.$emit('rams-saving', this);

        RAMS.updateController.abort()
        RAMS.updateController = new AbortController();
        await Http.put(
            route('api.v2.hsqe.rams.store', [this.packageReference, this.id]),
            this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes}), {
                signal: RAMS.updateController.signal
            }
        ).catch(err => {
        })
        this.lastSavedData = await Http.get(route('api.v2.hsqe.rams', [this.packageReference, this.id]))
        this.lastUpdatedOn = this.lastSavedData.lastUpdatedOn
        this.lastUpdatedBy = this.lastSavedData.lastUpdatedBy
        this.lastUpdatedByReference = this.lastSavedData.lastUpdatedByReference
        eventBus.$emit('rams-saved', this);
        this.saving = false;
    }

    async delete() {
        await Http.delete(route('api.v2.hsqe.rams.delete', [this.packageReference, this.id]))
    }

    async reload() {
        let o = await RAMS.find(this.packageReference, this.id)
        Object.assign(this, o)
    }
}
